
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { LicenseKey } from '@/types/licenseKey';

interface DomainsTabContentProps {
  domains: any[];
  licenseKeys: LicenseKey[];
}

const DomainsTabContent: React.FC<DomainsTabContentProps> = ({ domains, licenseKeys }) => {
  const navigate = useNavigate();
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Registered Domains</CardTitle>
        <CardDescription>Domains registered with license keys</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-3 px-4 text-sm font-medium">Domain</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Status</th>
                <th className="text-left py-3 px-4 text-sm font-medium">Registered</th>
                <th className="text-left py-3 px-4 text-sm font-medium">License</th>
              </tr>
            </thead>
            <tbody>
              {domains.slice(0, 5).map((domain) => (
                <tr key={domain.id} className="border-b hover:bg-gray-50">
                  <td className="py-3 px-4">{domain.domain}</td>
                  <td className="py-3 px-4">
                    <Badge variant={
                      domain.status === 'active' ? 'success' : 
                      domain.status === 'pending' ? 'warning' : 'destructive'
                    }>
                      {domain.status}
                    </Badge>
                  </td>
                  <td className="py-3 px-4">
                    {new Date(domain.createdAt).toLocaleDateString()}
                  </td>
                  <td className="py-3 px-4">
                    {licenseKeys.find(k => k.id === domain.licenseKeyId)?.key.substring(0, 10) || 'N/A'}...
                  </td>
                </tr>
              ))}
              {domains.length === 0 && (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-500">
                    No domains registered
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
      <CardFooter className="flex justify-center border-t pt-4">
        <Button variant="outline" onClick={() => navigate('/master-license/domains')}>
          Manage Domains
        </Button>
      </CardFooter>
    </Card>
  );
};

export default DomainsTabContent;
